import { FC } from "react";
import { useTranslation } from "react-i18next";
//import Button from "../ui/Button";
//import { ButtonVariant } from "../../types/constants";
import ImagePlaceholderSVG from "../shared/svg/ImagePlaceholder";
import { ICourseFlat } from "../../domain/models/Course";
import { Purpose } from "../../domain/enums/Purpose";
import { FILES_URL } from "../../Config";
import { formatDateLong } from "../../utils/DateUtils";
import HtmlContent from "../../custom-components/HtmlContent";

interface CourseContentSectionProps {
    course: ICourseFlat;
}

const CourseContentSection: FC<CourseContentSectionProps> = ({ course }) => {
    const { t } = useTranslation();

    const getImageUrl = () => {
        if (course.imageUrl) return course.imageUrl;
        if (course.files && course.files.length > 0) {
            const coverFile = course.files.find((file) => file.purposeType === Purpose.COVER);
            if (coverFile?.filePath) {
                return `${FILES_URL}/${coverFile.filePath}`;
            }
        }
        return null;
    };

    const imageUrl = getImageUrl();

    const imageElement = imageUrl ? (
        <img src={imageUrl} alt={course.title} className="w-full h-full object-cover rounded-[6px]" />
    ) : (
        <ImagePlaceholderSVG classname="w-full h-full" />
    );

    return (
        <section className="w-full">
            <div className="hidden lap:block">
                <div className="max-w-[1280px] mx-auto">
                    <h1 className="font-geologica font-medium text-[36px] leading-[1] uppercase text-primary-400 mb-[42px]">
                        {course.title}
                    </h1>
                </div>

                <div className="flex">
                    <div className="max-w-[1280px] w-full mx-auto flex gap-[42px]">
                        <div className="w-[548px] max-w-[548px] flex flex-col">
                            {course.shortContent && (
                                <p className="text-text-300 text-[16px] leading-[1.3] mb-[16px] break-words">
                                    {course.shortContent}
                                </p>
                            )}

                            {course.author && (
                                <p className="text-[16px] leading-[1.3] mb-[16px]" style={{ color: "#404040" }}>
                                    {t("courses.author")}: {course.author}
                                </p>
                            )}

                            <div className="text-text-300 text-[14px] leading-[1.3] mb-[32px] flex items-center gap-[21px] flex-wrap">
                                {course.duration && (
                                    <p>
                                        {t("courses.duration")}: {course.duration}
                                    </p>
                                )}
                                {course.topic && <p>{course.topic}</p>}
                                {course.createdAt && <p>{formatDateLong(course.createdAt)}</p>}
                            </div>

                            {/*
                             <div className="mt-auto">
                                <Button
                                    text={t("courses.goToCourse")}
                                    variant={ButtonVariant.PRIMARY}
                                    onClick={() => {}}
                                />
                            </div>
                            */}

                            {course.description && (
                                <HtmlContent
                                    html={course.description}
                                    className="text-text-300 text-[16px] leading-[1.3] mt-[16px]"
                                />
                            )}
                        </div>
                    </div>

                    <div className="w-[671px] h-[510px] flex-shrink-0 ml-auto">{imageElement}</div>
                </div>
            </div>

            <div className="hidden md:block lap:hidden max-w-[1280px] mx-auto">
                <h1 className="font-geologica font-medium text-[36px] leading-[1] uppercase text-primary-400 mb-[32px]">
                    {course.title}
                </h1>

                <div className="text-text-300 text-[14px] leading-[1.3] mb-[32px] flex items-center gap-[21px] flex-wrap">
                    {course.duration && (
                        <p>
                            {t("courses.duration")}: {course.duration}
                        </p>
                    )}
                    {course.topic && <p>{course.topic}</p>}
                    {course.createdAt && <p>{formatDateLong(course.createdAt)}</p>}
                </div>

                {course.shortContent && (
                    <p className="text-text-300 text-[16px] leading-[1.3] mb-[16px]">{course.shortContent}</p>
                )}

                {course.author && (
                    <p className="text-[16px] leading-[1.3] mb-[32px]" style={{ color: "#404040" }}>
                        {t("courses.author")}: {course.author}
                    </p>
                )}

                <div className="w-full h-[400px] mb-[32px]">{imageElement}</div>

                {/*
                <div>
                    <Button text={t("courses.goToCourse")} variant={ButtonVariant.PRIMARY} onClick={() => {}} />
                </div>
                */}

                {course.description && (
                    <HtmlContent html={course.description} className="text-text-300 text-[16px] leading-[1.3] mt-[16px]" />
                )}
            </div>

            <div className="md:hidden max-w-[1280px] mx-auto">
                <h1 className="font-geologica font-medium text-[36px] leading-[1] uppercase text-primary-400 mb-[32px] break-words">
                    {course.title}
                </h1>

                {course.author && (
                    <p className="text-[16px] leading-[1.3] mb-[34px] break-words" style={{ color: "#404040" }}>
                        {t("courses.author")}: {course.author}
                    </p>
                )}

                <div className="w-full h-[300px] mb-[24px]">{imageElement}</div>

                <div className="text-text-300 text-[14px] leading-[1.3] mb-[32px] flex flex-col gap-[8px]">
                    {course.duration && (
                        <p>
                            {t("courses.duration")}: {course.duration}
                        </p>
                    )}
                </div>

                {course.shortContent && (
                    <p className="text-text-300 text-[16px] leading-[1.3] mb-[16px] break-words">
                        {course.shortContent}
                    </p>
                )}

                {/*
                <div>
                    <Button text={t("courses.goToCourse")} variant={ButtonVariant.PRIMARY} onClick={() => {}} />
                </div>
                */}

                {course.description && (
                    <HtmlContent
                        html={course.description}
                        className="text-text-300 text-[16px] leading-[1.3] mt-[16px] break-words"
                    />
                )}
            </div>
        </section>
    );
};

export default CourseContentSection;
